<template>
  <div>
    <div class="q-mt-xl">
      <q-table
        v-if="tipoCatalogo == 'sim'"
        :columns="columns"
        :rows="produtosCatalogo.data"
        :loading="loading"
        dense
        :rows-per-page-options="[0]"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        selection="single"
        v-model:selected="selected"
        class="tabela-tamanho-fixo"
        flat
        row-key="id"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-right>
          <q-input
            v-model="filtros.busca"
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >EPI´s do Meu Catálogo</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong>
                    {{ props.row.id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Código: </strong>
                    {{ props.row.code }}</span
                  >
                  <div class="row col-12">
                    <span v-if="!props.selected" class="row q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Descrição: </strong>
                      {{
                        props.row.pivot &&
                        props.row.pivot.contract_product_description
                          ? props.row.pivot.contract_product_description
                          : ""
                      }}</span
                    >
                    <span class="row q-ml-sm q-mt-sm items-center" v-else
                      ><strong class="q-mr-xs">Descrição: </strong>
                      <input v-model="dados.descricao" class="input-grid" />
                    </span>
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Grupo: </strong>
                    {{ props.row.pivot?.product_group?.name }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Categoria: </strong>
                    {{ props.row.pivot?.product_category?.code }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">CA: </strong>
                    {{
                      props.row.pivot ? props.row.pivot?.ca?.code : "Sem CA"
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Min.: </strong>
                    {{ props.row.stock[0]?.pivot?.minimal_amount }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Max.: </strong>
                    {{ props.row.stock[0]?.pivot?.max_amount }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Ponto Reposição: </strong>
                    {{ props.row.stock[0]?.pivot?.replacement_amount }}</span
                  >
                  <div class="row col-12">
                    <span v-if="!props.selected" class="row q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Preço Atual: </strong>
                      {{ props.row.pivot?.price }}</span
                    >
                    <span class="row q-ml-sm q-mt-sm items-center" v-else
                      ><strong class="q-mr-xs">Preço Atual: </strong>
                      <input v-model="dados.preco" class="input-grid" />
                    </span>
                  </div>
                </div>
                <div class="col-5">
                  <div class="row justify-end q-gutter-x-xs">
                    <div>
                      <q-btn
                        flat
                        icon="edit"
                        color="primary"
                        round
                        @click="editarProduto(props.row.id)"
                      />
                    </div>
                    <div>
                      <q-btn
                        icon="privacy_tip"
                        color="yellow-7"
                        flat
                        round
                        @click="alterarEstadoEpi(props.row, 0)"
                      />
                    </div>
                    <div>
                      <q-btn
                        icon="delete"
                        color="negative"
                        flat
                        round
                        @click="removerProduto(props.row.id)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td style="white-space: normal">
              <span> {{ props.row.id }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.code }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span v-if="!props.selected">
                {{
                  props.row.pivot &&
                  props.row.pivot.contract_product_description
                    ? props.row.pivot.contract_product_description
                    : ""
                }}</span
              >
              <q-input
                v-else
                dense
                outlined
                v-model="dados.descricao"
                style="width: 110px"
              />
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.pivot?.product_group?.name }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.pivot?.product_category?.code }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span>
                {{
                  props.row.pivot ? props.row.pivot?.ca?.code : "Sem CA"
                }}</span
              >
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.stock[0]?.pivot?.minimal_amount }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.stock[0]?.pivot?.max_amount }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.stock[0]?.pivot?.replacement_amount }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span v-if="!props.selected"> {{ props.row.pivot?.price }}</span>
              <q-input
                v-else
                v-model="dados.preco"
                dense
                outlined
                style="width: 110px"
              />
            </q-td>
            <q-td style="white-space: normal">
              <q-btn
                flat
                icon="edit"
                color="primary"
                round
                @click="editarProduto(props.row.id)"
              />
            </q-td>
            <q-td style="white-space: normal">
              <div class="row justify-center">
                <q-btn
                  icon="privacy_tip"
                  flat
                  color="yellow-7"
                  round
                  @click="alterarEstadoEpi(props.row, 0)"
                />
              </div>
            </q-td>
            <q-td style="white-space: normal">
              <q-btn
                icon="delete"
                color="negative"
                round
                flat
                @click="removerProduto(props.row.id)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <q-table
        v-if="tipoCatalogo == 'nao'"
        :columns="columns"
        :rows="produtosCatalogo.data"
        :loading="loading"
        :rows-per-page-options="[0]"
        dense
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        selection="single"
        v-model:selected="selected"
        flat
        class="tabela-tamanho-fixo"
        row-key="id"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-right>
          <q-input
            v-model="filtros.busca"
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >EPI´s do Meu Catálogo</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong>
                    {{ props.row.id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Código: </strong>
                    {{ props.row.code }}</span
                  >
                  <div class="row col-12">
                    <span v-if="!props.selected" class="row q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Descrição: </strong>
                      {{ props.row?.pivot?.contract_product_description }}</span
                    >
                    <span class="row q-ml-sm q-mt-sm items-center" v-else
                      ><strong class="q-mr-xs">Descrição: </strong>
                      <input v-model="dados.descricao" class="input-grid" />
                    </span>
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Grupo: </strong>
                    {{ props.row.pivot?.product_group?.name }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Categoria: </strong>
                    {{ props.row.pivot?.product_category?.code }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">CA: </strong>
                    {{
                      props.row.pivot ? props.row.pivot?.ca?.code : "Sem CA"
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Min.: </strong>
                    {{ props.row.stock[0]?.pivot?.minimal_amount }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Max.: </strong>
                    {{ props.row.stock[0]?.pivot?.max_amount }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Ponto Reposição: </strong>
                    {{ props.row.stock[0]?.pivot?.replacement_amount }}</span
                  >
                  <div class="row col-12">
                    <span v-if="!props.selected" class="row q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Preço Atual: </strong>
                      {{ props.row.pivot?.price }}</span
                    >
                    <span class="row q-ml-sm q-mt-sm items-center" v-else
                      ><strong class="q-mr-xs">Preço Atual: </strong>
                      <input v-model="dados.preco" class="input-grid" />
                    </span>
                  </div>
                </div>
                <div class="col-5">
                  <div class="row justify-end q-gutter-x-xs">
                    <div>
                      <q-btn
                        flat
                        icon="edit"
                        color="primary"
                        round
                        @click="editarProduto(props.row.id)"
                      />
                    </div>
                    <div>
                      <q-btn
                        icon="add_moderator"
                        color="positive"
                        flat
                        round
                        @click="alterarEstadoEpi(props.row, 1)"
                      />
                    </div>
                    <div>
                      <q-btn
                        icon="delete"
                        color="negative"
                        flat
                        round
                        @click="removerProduto(props.row.id)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{
                col.label == "Tratar como Não EPI"
                  ? "Tratar como EPI"
                  : col.label
              }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td style="white-space: normal">
              <span> {{ props.row.id }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.code }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span v-if="!props.selected">
                {{
                  props.row.pivot &&
                  props.row.pivot.contract_product_description
                    ? props.row.pivot.contract_product_description
                    : ""
                }}</span
              >
              <q-input
                style="width: 110px"
                v-else
                dense
                outlined
                v-model="dados.descricao"
              />
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.pivot?.product_group?.name }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.pivot?.product_category?.code }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span>
                {{
                  props.row.pivot ? props.row.pivot?.ca?.code : "Sem CA"
                }}</span
              >
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.stock[0]?.pivot?.minimal_amount }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.stock[0]?.pivot?.max_amount }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.stock[0]?.pivot?.replacement_amount }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span v-if="!props.selected"> {{ props.row.pivot?.price }}</span>
              <q-input
                v-else
                v-model="dados.preco"
                dense
                outlined
                style="width: 90px"
              />
            </q-td>
            <q-td style="white-space: normal">
              <q-btn
                flat
                icon="edit"
                color="primary"
                round
                @click="editarProduto(props.row.id)"
              />
            </q-td>
            <q-td style="white-space: normal">
              <div class="row justify-center">
                <q-btn
                  icon="add_moderator"
                  color="positive"
                  flat
                  round
                  @click="alterarEstadoEpi(props.row, 1)"
                />
              </div>
            </q-td>
            <q-td style="white-space: normal">
              <q-btn
                icon="delete"
                flat
                color="negative"
                round
                @click="removerProduto(props.row.id)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <q-table
        v-if="tipoCatalogo == ''"
        :columns="columns2"
        :rows="produtosCatalogo.data"
        :loading="loading"
        :rows-per-page-options="[0]"
        color="primary"
        dense
        table-header-class="bg-accent text-weight-bold"
        selection="single"
        hide-pagination
        class="tabela-tamanho-fixo"
        v-model:selected="selected"
        flat
        row-key="id"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-right>
          <q-input
            v-model="filtros.busca"
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Itens do meu catálogo</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong>
                    {{ props.row.id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Código: </strong>
                    {{ props.row.code }}</span
                  >
                  <div class="row col-12">
                    <span v-if="!props.selected" class="row q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Descrição: </strong>
                      {{
                        props.row.pivot &&
                        props.row.pivot.contract_product_description
                          ? props.row.pivot.contract_product_description
                          : ""
                      }}</span
                    >
                    <span class="row q-ml-sm q-mt-sm items-center" v-else
                      ><strong class="q-mr-xs">Descrição: </strong>
                      <input v-model="dados.descricao" class="input-grid" />
                    </span>
                  </div>
                  <div class="row col-12">
                    <span
                      v-if="props.row.pivot?.product_group?.name"
                      class="row q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Grupo: </strong>
                      {{ props.row.pivot?.product_group?.name }}</span
                    >
                    <span
                      class="row q-ml-sm q-mt-sm"
                      v-else-if="
                        props.selected && !props.row.pivot?.product_group?.name
                      "
                      ><strong class="q-mr-xs">Grupo: </strong>
                      <select v-model="grupoGrid" name="select" class="select">
                        <option
                          v-for="(grupo, index) in grupos"
                          :value="grupo.value"
                          :key="index"
                        >
                          {{ grupo.label }}
                        </option>
                      </select>
                    </span>
                    <span v-else class="row q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Grupo: </strong>
                    </span>
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Categoria: </strong>
                    {{ props.row.pivot?.product_category?.code }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">CA: </strong>
                    {{
                      props.row.pivot ? props.row.pivot?.ca?.code : "Sem CA"
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Min.: </strong>
                    {{ props.row.stock[0]?.pivot?.minimal_amount }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Max.: </strong>
                    {{ props.row.stock[0]?.pivot?.max_amount }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Ponto Reposição: </strong>
                    {{ props.row.stock[0]?.pivot?.replacement_amount }}</span
                  >
                  <div class="row col-12">
                    <span v-if="!props.selected" class="row q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Preço Atual: </strong>
                      {{ props.row.pivot?.price }}</span
                    >
                    <span class="row q-ml-sm q-mt-sm items-center" v-else
                      ><strong class="q-mr-xs">Preço Atual: </strong>
                      <input v-model="dados.preco" class="input-grid" />
                    </span>
                  </div>
                </div>
                <div class="col-5">
                  <div class="row justify-end q-mb-md">
                    <div>
                      <div class="text-bold">EPI (N/S)</div>
                      <q-toggle
                        v-if="props.row.pivot.isEpi == null"
                        v-model="props.row.pivot.isEpi"
                        :false-value="null"
                        :true-value="1"
                        @click="
                          controlarEstadoEpi(props.row, props.row.pivot.isEpi)
                        "
                        :disable="disable2"
                      />
                      <q-toggle
                        v-else
                        v-model="props.row.pivot.isEpi"
                        :false-value="0"
                        :true-value="1"
                        @click="
                          controlarEstadoEpi(props.row, props.row.pivot.isEpi)
                        "
                        :disable="disable2"
                      />
                    </div>
                  </div>
                  <div class="row justify-end q-gutter-x-xs">
                    <div>
                      <q-btn
                        flat
                        icon="edit"
                        color="primary"
                        round
                        @click="editarProduto(props.row.id)"
                      />
                    </div>
                    <div>
                      <q-btn
                        icon="delete"
                        color="negative"
                        flat
                        round
                        @click="removerProduto(props.row.id)"
                      />
                    </div>
                    <div>
                      <q-btn
                        icon="info"
                        color="primary"
                        flat
                        round
                        @click="editarProduto(props.row.id)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label == "Tratar como Não EPI" ? "EPI (N/S)" : col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td style="white-space: normal">
              <span> {{ props.row.id }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.code }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span v-if="!props.selected">
                {{
                  props.row.pivot &&
                  props.row.pivot.contract_product_description
                    ? props.row.pivot.contract_product_description
                    : ""
                }}</span
              >
              <q-input
                v-else
                dense
                outlined
                style="width: 110px"
                v-model="dados.descricao"
              />
            </q-td>
            <q-td style="white-space: normal">
              <span v-if="props.row.pivot?.product_group?.name">
                {{ props.row.pivot?.product_group?.name }}</span
              >
              <q-select
                v-if="props.selected && !props.row.pivot?.product_group?.name"
                v-model="grupo"
                :options="grupos"
                dense
                outlined
                style="width: 130px"
              />
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.pivot?.product_category?.code }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span>
                {{
                  props.row.pivot && props.row.pivot.ca != null
                    ? props.row.pivot.ca.code
                    : "Sem CA"
                }}</span
              >
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.stock[0]?.pivot?.minimal_amount }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.stock[0]?.pivot?.max_amount }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.stock[0]?.pivot?.replacement_amount }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span v-if="!props.selected"> {{ props.row.pivot?.price }}</span>
              <q-input
                v-else
                v-model="dados.preco"
                dense
                outlined
                style="width: 90px"
              />
            </q-td>
            <q-td style="white-space: normal">
              <div class="row justify-center">
                <q-btn
                  flat
                  icon="edit"
                  color="primary"
                  round
                  @click="editarProduto(props.row.id)"
                />
              </div>
            </q-td>
            <q-td style="white-space: normal">
              <div class="row justify-center">
                <q-toggle
                  v-if="props.row.pivot.isEpi == null"
                  v-model="props.row.pivot.isEpi"
                  :false-value="null"
                  :true-value="1"
                  @click="controlarEstadoEpi(props.row, props.row.pivot.isEpi)"
                  :disable="disable2"
                />
                <q-toggle
                  v-else
                  v-model="props.row.pivot.isEpi"
                  :false-value="0"
                  :true-value="1"
                  @click="controlarEstadoEpi(props.row, props.row.pivot.isEpi)"
                  :disable="disable2"
                />
              </div>
            </q-td>
            <q-td style="white-space: normal">
              <q-btn
                icon="delete"
                flat
                color="negative"
                round
                @click="removerProduto(props.row.id)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <!-- Modal de confirmação para alterar estado EPI -->
    <DialogConfirmDesign
      :mensagem="modalAlterarEpi.mensagem"
      :exibir="modalAlterarEpi.exibir"
      :titulo="modalAlterarEpi.titulo"
      @resultado="confirmarAlterarEpi"
    />

    <!-- Modal de confirmação para remover produto -->
    <DialogConfirmDesign
      :mensagem="modalRemover.mensagem"
      :exibir="modalRemover.exibir"
      :titulo="modalRemover.titulo"
      @resultado="confirmarRemover"
    />
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "categoria",
    label: "Categoria",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "ca",
    label: "CA",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "estoqueminimo",
    label: "Estoque Min.",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "estoquemaximo",
    label: "Estoque Max.",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "pontoresposicao",
    label: "Ponto de Reposição",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "precoatual",
    label: "Preço Atual",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "editar",
    label: "Editar",
    align: "center",
    style: "white-space: normal",
  },
  {
    name: "tratarcomoepi",
    label: "Tratar como Não EPI",
    align: "center",
    style: "white-space: normal",
  },
  {
    name: "remover",
    label: "Remover",
    align: "center",
    style: "white-space: normal",
  },
];
const columns2 = [
  {
    name: "id",
    label: "ID",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    field: (row) => row?.contract_product_description,
    style: "white-space: normal",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "categoria",
    label: "Categoria",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "ca",
    label: "CA",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "estoqueminimo",
    label: "Estoque Min.",
    align: "left",

    style: "white-space: normal",
  },
  {
    name: "estoquemaximo",
    label: "Estoque Max.",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "pontoresposicao",
    label: "Ponto de Reposição",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "precoatual",
    label: "Preço Atual",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "editar",
    label: "Editar",
    align: "center",
    style: "white-space: normal",
  },
  {
    name: "tratarcomoepi",
    label: "Tratar como Não EPI",
    align: "center",
    style: "white-space: normal",
  },
  {
    name: "remover",
    label: "Remover",
    align: "center",
    style: "white-space: normal",
  },
];
export default {
  props: ["produtosCatalogo", "tipoCatalogo", "catalogoId", "vendorId"],
  emits: ["buscar", "paginarTabela", "atualizarTabela"],
  components: {
    DialogConfirmDesign,
  },
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    const selected = ref([]);
    const filtros = ref({ busca: "" });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: props.produtosCatalogo.current_page,
      rowsPerPage: props.produtosCatalogo.per_page,
      rowsNumber: props.produtosCatalogo.total,
    });
    let loading = ref(false);
    let disable = ref(false);
    let disable2 = ref(false);
    const dados = ref({ descricao: "", preco: "" });
    const grupos = ref([]);
    const grupo = ref({
      label: "Grupo",
      value: "",
    });
    const grupoGrid = ref("");

    // Modais de confirmação
    const modalAlterarEpi = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Alteração",
      produto: null,
      estadoEpi: null,
    });

    const modalRemover = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Remoção",
      produtoId: null,
    });

    watch(
      () => filtros.value.busca,
      () => {
        emit("buscar", filtros.value.busca);
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        emit(
          "paginarTabela",
          pagination.value.page,
          pagination.value.rowsPerPage
        );
        disable.value = true;
        loading.value = true;
      }
    );

    const alterarEstadoEpi = async (product, estadoEpi) => {
      if (product.ca) {
        quasar.notify({
          message:
            "Produtos com CA não podem ser removidos do catálogo de EPI, remova o CA antes de remover o produto deste catálogo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      // Abre modal de confirmação
      modalAlterarEpi.value.produto = product;
      modalAlterarEpi.value.estadoEpi = estadoEpi;
      if (estadoEpi == 0) {
        modalAlterarEpi.value.mensagem =
          "Tem certeza que deseja tratar esse item como Não EPI?";
      } else {
        modalAlterarEpi.value.mensagem =
          "Tem certeza que deseja tratar esse item como EPI?";
      }
      modalAlterarEpi.value.exibir = true;
    };

    const confirmarAlterarEpi = async (confirmado) => {
      modalAlterarEpi.value.exibir = false;

      if (!confirmado) {
        modalAlterarEpi.value.produto = null;
        modalAlterarEpi.value.estadoEpi = null;
        return;
      }

      const product = modalAlterarEpi.value.produto;
      const estadoEpi = modalAlterarEpi.value.estadoEpi;

      let mensagem = "";
      if (estadoEpi == 0) {
        mensagem = "Produto alterado para não epi com sucesso";
      } else {
        mensagem = "Produto alterado para epi com sucesso";
      }

      try {
        await store.dispatch("catalogo/alterarEstadoEpi", {
          contract_id: props.catalogoId,
          isEpi: estadoEpi,
          product_id: product.id,
        });
        emit(
          "paginarTabela",
          pagination.value.page,
          pagination.value.rowsPerPage
        );
        quasar.notify({
          message: mensagem,
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao alterar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalAlterarEpi.value.produto = null;
      modalAlterarEpi.value.estadoEpi = null;
    };

    const controlarEstadoEpi = async (product, estadoEpi) => {
      try {
        disable2.value = true;
        await store.dispatch("catalogo/alterarEstadoEpi", {
          contract_id: props.catalogoId,
          isEpi: estadoEpi,
          product_id: product.id,
        });
        emit("atualizarTabela");
        quasar.notify({
          message: "Atualizado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable2.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao alterar",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerProduto = async (product_id) => {
      // Abre modal de confirmação
      modalRemover.value.produtoId = product_id;
      modalRemover.value.mensagem = "Tem certeza que deseja remover esse Item?";
      modalRemover.value.exibir = true;
    };

    const confirmarRemover = async (confirmado) => {
      modalRemover.value.exibir = false;

      if (!confirmado) {
        modalRemover.value.produtoId = null;
        return;
      }

      const product_id = modalRemover.value.produtoId;

      try {
        await store.dispatch("catalogo/removerProduto", {
          contract_id: props.catalogoId,
          product_id: product_id,
        });
        quasar.notify({
          message: "Produto removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit(
          "paginarTabela",
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao remover produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalRemover.value.produtoId = null;
    };

    const atualizarDadosProduto = async (produto) => {
      if (
        dados.value.descricao == produto.pivot.contract_product_description &&
        dados.value.preco == produto.pivot.price &&
        grupoGrid.value == "" &&
        grupo.value.value == ""
      ) {
        selected.value = [];
        return;
      }
      try {
        await store.dispatch("catalogo/atualizarProduto", {
          catalog_id: props.catalogoId,
          contract_product_description: dados.value.descricao,
          price: dados.value.preco,
          product_id: produto.id,
        });
        if (grupoGrid.value != "" || grupo.value.value != "0") {
          adicionarGrupoProduto(produto);
        }
        quasar.notify({
          message: "Informações do produto atuaçizadas com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        selected.value = [];
        emit(
          "paginarTabela",
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao atualizar informações do produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const recebeDados = (produto) => {
      dados.value = {
        descricao: produto.pivot.contract_product_description,
        preco: produto.pivot.price,
      };
    };

    const listarGrupos = async () => {
      grupos.value = [];
      const response = await store.dispatch("catalogo/listarGrupos", {
        vendor_id: props.catalogoId,
        per_page: 1000,
      });

      let array = response.data.results.data;
      array.forEach((grupo) => {
        grupos.value.push({
          label: grupo.name,
          value: grupo.id,
        });
      });
    };

    const adicionarGrupoProduto = async (product) => {
      let grupoId = grupo.value.value;

      if (grupoGrid.value != "") {
        grupoId = grupoGrid.value;
      }
      try {
        await store.dispatch("catalogo/adicionarGrupoProduto", {
          catalog_id: props.catalogoId,
          product_group_id: grupoId,
          product_id: product.id,
        });
        selected.value = [];
        emit(
          "paginarTabela",
          pagination.value.page,
          pagination.value.rowsPerPage
        );
        grupoGrid.value = "";
        grupo.value.value = "";
      } catch (error) {
        console.log(error);
      }
    };

    const editarProduto = async (produtoId) => {
      router.push({
        name: "catalogo-gestaocatalogo-editar-produto",
        params: { produtoId: produtoId, unidadeId: props.catalogoId },
        query: props.vendorId ? { vendorId: props.vendorId } : {},
      });
    };

    watch(
      () => props.produtosCatalogo,
      () => {
        pagination.value.rowsPerPage = props.produtosCatalogo.per_page;
        pagination.value.page = props.produtosCatalogo.current_page;
        pagination.value.rowsNumber = props.produtosCatalogo.total;
        disable.value = false;
        loading.value = false;
      }
    );

    onMounted(listarGrupos);

    return {
      columns,
      columns2,
      selected,
      filtros,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      alterarEstadoEpi,
      confirmarAlterarEpi,
      removerProduto,
      confirmarRemover,
      atualizarDadosProduto,
      dados,
      recebeDados,
      controlarEstadoEpi,
      disable2,
      listarGrupos,
      grupo,
      grupos,
      grupoGrid,
      adicionarGrupoProduto,
      editarProduto,
      modalAlterarEpi,
      modalRemover,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-exportar {
    font-size: 12px;
  }
  .container-input-search {
    margin: 17px 0px;
  }
  .input-grid {
    width: 80px;
    outline: none;
  }
  .select {
    width: 120px;
    outline: none;
  }
}
</style>
